import styled from 'styled-components/'

export const ColorPickerContainer = styled.div`
  position: relative;
  top: 30px;
  left: -50px;
  width: 0;
  height: 0;
  z-index: 1000;
`
